/**
 * form item component (common control group in forms)
 * 
 * Properties:
 * 
 *      name:               string, name to identify changed item on callback (onChangeHandler)
 *      type:               string, type of form group ('label', 'select', 'datePicker', 'input')
 *      label:              string, label to be displayed (or button text)
 *      link:               string, html-ref for type "button" (can also be "#")
 *      icon:               string, class name of icon to be displayed (type "button")
 *      beautify:           boolean, displaying type "button" beautified"
 *      round:              boolean, displaying type "button" with rounded corners
 *      placeholder:        string, placeholder for user input
 *      options:            array, options for select box (objects containing name and value)
 *      selected:           object, currently selected date for date picker
 *      dateFormat:         string, date format for date picker
 *      datePickerClass:    string, class of date picker
 *      onChangeHandler:    function, callback for changes (also click events for type "button")
 *      mediumWidth:        number, number of columns used for this element on big screens
 *      smallWidth:         number, number of columns used for this element on small screens
 *      extraTopClasses:    string, space separated class names controlling style attributes of whole block
 */

import React from "react";
import de from "date-fns/locale/de"; // @todo Make dynamic
import en from "date-fns/locale/en-GB";
import fr from "date-fns/locale/fr";
// @ts-ignore
import DatePicker from "react-datepicker";
import { Biscuit } from "../../utils";
import LargeButton from "./LargeButton";
import Select2 from "./select2";
import Multiselect from "./Multiselect"
import TimeInput from "./timeinput";
import InputNew from './InputNew';
import Editor from "./editor";
import InboomaSelectBox from "./InboomaSelectBox";
import SwitchPaddle from "./switchpaddle";
import {type Filter, type FieldsMap} from './Types/InboomaSelectBoxTypes';

type SubAddButtonData = {
    handler: (e: any) => void,
    id: string,
    class: string,
    i: string,
    label: string
};

type Props = {
    extraTopClasses?: string,
    selected?: any,
    onChangeHandler: (item: any, name?: string) => void,
    selectStyle?: React.CSSProperties,
    labelStyle?: React.CSSProperties,
    checkBoxStyle?: React.CSSProperties,
    switchStyle?: React.CSSProperties,
    inputStyle?: React.CSSProperties,
    inputMainStyle?: React.CSSProperties,
    disabled?: boolean,
    type: string,
    name?: string,
    label?: string,
    largeWidth?: string|number|undefined,
    mediumWidth?: string|number|undefined,
    smallWidth?: string|number|undefined,
    style?: React.CSSProperties,
    datePickerClass?: string,
    dateFormat?: string,
    withName?: boolean,
    placeholder?: string,
    data?: any,
    onQueryHandler?: (e: any) => void,
    valprop?: string,
    valkey?: string,
    selectedItems?: any,
    setSelectedItems?: (items: any) => void,
    triggerOnChange?: () => void,
    nameSub?: string,
    nameAttribute?: string,
    dataKey?: string,
    link?: string,
    beautify?: boolean,
    round?: boolean,
    icon?: string,
    inputType?: string,
    notTiny?: boolean,
    htmlFor?: string,
    value?: any,
    helpText?: string,
    id?: string | number,
    unit?: string,
    noIdForName?: boolean,
    min?: number,
    max?: number,
    theme?: string,
    readOnly?: boolean,
    sortBy?: string,
    sortDirection?: string,
    advanced?: boolean,
    dispatch?: (payload: any) => void,
    container?: string,
    multiSelect?: boolean,
    extraStyle?: object,
    onRemoveHandler?: () => void,
    fields?: FieldsMap,
    showFields?: (string)[],
    searchParams?: {
        [key:string]: string[]|string
    },
    model?: string,
    extraFilter?: Filter,
    subAddButton?: boolean,
    subAddButtonData?: SubAddButtonData,
    onReset?: any,
    buttonName?: string,
    buttonTitle?: string,
    onClickHandler?: (e: any) => void,
    big?: boolean
};
const FormItem = ({
                      extraTopClasses,
                  selected,
                  onChangeHandler,
                  selectStyle,
                  labelStyle,
                  checkBoxStyle,
                  inputMainStyle,
                  switchStyle,
                  inputStyle,
                  disabled,
                  type,
                  name,
                  label,
                  largeWidth,
                  mediumWidth,
                  smallWidth,
                  style,
                  datePickerClass,
                  dateFormat,
                  withName,
                  placeholder,
                  data,
                  onQueryHandler,
                  valprop,
                  valkey,
                  selectedItems,
                  setSelectedItems,
                  triggerOnChange,
                  nameSub,
                  nameAttribute,
                  dataKey,
                  link,
                  beautify,
                  round,
                  icon,
                  inputType,
                  notTiny,
                  htmlFor,
                  value,
                  helpText,
                  id,
                  unit,
                  noIdForName,
                  min,
                  max,
                  theme,
                  readOnly,
                  sortBy,
                  sortDirection,
                  advanced,
                  dispatch,
                  container,
                  multiSelect,
                  extraStyle,
                  onRemoveHandler,
                  fields,
                  showFields,
                  searchParams,
                  model,
                  extraFilter,
                  subAddButton,
          subAddButtonData,
            onReset,
                   buttonName,
                buttonTitle,
    onClickHandler,
    big = false
                  }: Props ) => {

    let extraClasses = extraTopClasses ? extraTopClasses : "";
    let _activeValue = typeof selected !== 'undefined'?selected:null;
    const dateLocale = Biscuit.get('user.lang').indexOf('de') >= 0 ? de : (Biscuit.get('user.lang').indexOf('fr') >= 0 ? fr : en);
    const labelLocal = typeof label !== 'undefined' ? label : '';
    const nameLocal = typeof name !== 'undefined' ? name : '';
    const unitLocal = typeof unit !== 'undefined' ? unit : 'minutes';
    const onSelectHandler = (item: any) => {

        onChangeHandler(item);
    };

    const onUnselectHandler = () => {

        onChangeHandler(null);
    };

    if(typeof selectStyle === 'undefined'){
        selectStyle = {};
    }
    if(typeof labelStyle === 'undefined'){
        labelStyle = {};
    }
    selectStyle.marginRight = "1rem";
    selectStyle.backgroundPosition = "right 0 center";
   
    return (
        <div className={"list-item-block-offcanvas "+ "large-" + largeWidth + " medium-" + mediumWidth + " small-" + smallWidth + " column " + extraClasses} style={typeof style !== 'undefined'?style:{}}>
            {type === "datePicker" &&
            <>
                <label style={labelStyle}>{label}</label>
                <DatePicker
                    key={"inb-form-item-" + Math.floor(Math.random() * 10000)}
                    name={name}
                    className={datePickerClass}
                    dateFormat={dateFormat}
                    selected={selected}
                    onChange={(typeof withName !== 'undefined' && withName? (date: any) => onChangeHandler(date,name):(date: any) => onChangeHandler(date))}
                    onKeyDown={(e:React.KeyboardEvent<HTMLInputElement>) => {
                    if (e.keyCode === 8) e.preventDefault();
                    }}
                    placeholderText={placeholder}
                    locale={dateLocale}
                />
            </>}
            {type === "select2" &&
            <>
                <label style={labelStyle}>{label}</label>
                <Select2
                    placeholder={typeof placeholder !== 'undefined'?placeholder:''}
                    data={data}
                    nameAttribute={name}
                    selectHandle={onSelectHandler}
                    removeHandle={onUnselectHandler}
                    queryHandle={onQueryHandler}
                />
            </>}

            {type === "multiSelect" && typeof setSelectedItems !== 'undefined' && typeof triggerOnChange !== 'undefined' && typeof data !== 'undefined' &&
                <>
                    <label style={labelStyle}>{label}</label>
                    <Multiselect
                        placeholder={placeholder}
                        data={data}
                        valprop={typeof valprop !== 'undefined'?valprop:'name'}
                        valkey={typeof valkey !== 'undefined'?valkey:'name'}
                        selectedItems={selectedItems}
                        setSelectedItems={setSelectedItems}
                        triggerOnChange={triggerOnChange}
                    />
                </>}

            {type === "select" &&  typeof data !== 'undefined' &&
                <>
                <label style={labelStyle}>{label}</label>
                    {typeof name === 'undefined' && <>
                        <select className="inb-vert-list" style={selectStyle} onChange={(e) => onChangeHandler(e)}
                                value={_activeValue} disabled={disabled}>

                            {typeof placeholder !== 'undefined' &&
                                // @ts-ignore
                                <option value={null}
                                        key={"null_val"}>{placeholder}</option>}
                            {data.map((item:any, index:any) => {
                                if(typeof nameSub !== 'undefined'){
                                    return (
                                        // @ts-ignore
                                        <option value={item[dataKey]}
                                                key={index}>{nameAttribute ? item[nameSub][nameAttribute] : item[nameSub].name}</option>
                                    )
                                }
                                return (
                                    // @ts-ignore
                                    <option value={item[dataKey]}
                                            key={index}>{nameAttribute ? item[nameAttribute] : item.name}</option>
                                )
                            })}
                        </select>
                    </>
                    }
                    {typeof name !== 'undefined' && <>
                        <select className="inb-vert-list" style={selectStyle} onChange={(e) => onChangeHandler(e,name)}
                                value={_activeValue} disabled={disabled}>
                            {typeof placeholder !== 'undefined' &&
                                // @ts-ignore
                                <option value={null}
                                        key={"null_val"}>{placeholder}</option>}
                            {data.map((item:any, index:any) => {
                                return (
                                    // @ts-ignore
                                    <option value={item[dataKey]}
                                            key={index}>{nameAttribute ? item[nameAttribute] : item.name}</option>
                                )
                            })}
                        </select>
                    </>
                    }
                </>
                }

            {type === "button" &&
            <>
                <div className="list-item-button-container">
                    <LargeButton
                        link={link}
                        beautify={beautify}
                        round={round}
                        icon={icon}
                        title={label}
                        name={name}
                        inputType={inputType}
                        handler={onChangeHandler}/>
                </div>
            </>
            }
            {type === "checkbox" &&
                <>
                    <SwitchPaddle
                        label={labelLocal}
                        labelStyle={labelStyle}
                        switchStyle={switchStyle}
                        checkBoxStyle={checkBoxStyle}
                        onChange={onChangeHandler}
                        name={nameLocal}
                        disabled={disabled}
                        smallWidth={smallWidth}
                        mediumWidth={mediumWidth}
                        largeWidth={largeWidth}
                        // @ts-ignore
                        id={id}
                        htmlFor={htmlFor}
                        value={value}
                        notTiny={(typeof notTiny !== 'undefined'?notTiny:false)}
                    />
                    {typeof helpText !== 'undefined' && <><br/><br/><br/><span className="help-text">{helpText}</span></> }
                </>
            }
            {type === "time-input" &&
                <>
                    <TimeInput
                        label={labelLocal}
                        onChange={onChangeHandler}
                        name={nameLocal}
                        // @ts-ignore
                        id={id}
                        value={value}
                        unit={unitLocal}
                        big={big}
                        />
                </>

            }
            {type === "input" &&
                typeof label !== 'undefined' &&
                typeof value !== 'undefined' &&
                typeof name !== 'undefined' &&
                typeof value !== 'undefined' &&
                typeof inputType !== 'undefined' &&
                <>
                    <InputNew
                        label={label}
                        labelStyle={labelStyle}
                        inputStyle={inputStyle}
                        inputMainStyle={inputMainStyle}
                        onChange={onChangeHandler}
                        noIdForName={(typeof noIdForName !== 'undefined' ? noIdForName : false)}
                        value={value}
                        name={name}
                        disabled={typeof disabled !== 'undefined'?disabled:false}
                        id={typeof id !== 'undefined'?id:''}
                        type={inputType}
                        min={typeof min !== 'undefined'?min:1}
                        max={typeof max !== 'undefined'?max:65536}
                        notTiny={(typeof notTiny !== 'undefined' && notTiny)}
                    />
                </>

            }
            {type === "inputWithSubmit" &&
                typeof label !== 'undefined' &&
                typeof value !== 'undefined' &&
                typeof name !== 'undefined' &&
                typeof value !== 'undefined' &&
                typeof inputType !== 'undefined' &&
                typeof buttonName !== 'undefined' &&
                typeof buttonTitle !== 'undefined' &&
                typeof onClickHandler !== 'undefined' &&
                <>
                    <InputNew
                        label={label}
                        labelStyle={labelStyle}
                        inputStyle={inputStyle}
                        onChange={onChangeHandler}
                        noIdForName={(typeof noIdForName !== 'undefined' ? noIdForName : false)}
                        value={value}
                        name={name}
                        disabled={typeof disabled !== 'undefined'?disabled:false}
                        id={typeof id !== 'undefined'?id:''}
                        type={inputType}
                        min={typeof min !== 'undefined'?min:1}
                        max={typeof max !== 'undefined'?max:65536}
                        notTiny={(typeof notTiny !== 'undefined' && notTiny)}
                    />
                    <LargeButton
                        link="#"
                        beautify={true}
                        round={true}
                        title={buttonTitle}
                        name={buttonName}
                        handler={onClickHandler}/>

                </>

            }
            {type === "editor" &&
                <>
                      <Editor
                          label={labelLocal}
                          labelStyle={labelStyle}
                          theme={(typeof theme !== 'undefined'?theme:"snow")}
                          name={nameLocal}
                          readOnly={readOnly}
                          value={value}
                          onChange={onChangeHandler}
                          ></Editor>
                </>
            }
            {type === 'inboomaSelect' &&
                <>
                    <label className="inb-form__controlLabel" style={labelStyle}>{label}</label>
                    <div className="inb-form__controllClass">
                        {typeof setSelectedItems !== 'undefined' &&
                            typeof dispatch !== 'undefined' && typeof onReset !== 'undefined' &&
                        <InboomaSelectBox
                            sortBy={(typeof sortBy !== 'undefined'?sortBy:'name')}
                            sortDirection={(typeof sortDirection !== 'undefined'?sortDirection:'asc')}
                            quickOrder={true}
                            advanced={(typeof advanced !== 'undefined'?advanced:false)}
                            placeholder={placeholder}
                            selectedItems={selectedItems}
                            setSelectedItems={setSelectedItems}
                            onSelectItem={onChangeHandler}
                            dispatch={dispatch}
                            container={(typeof container !== 'undefined'?container:'order-vcard')}
                            multiSelect={multiSelect}
                            extraStyle={(typeof extraStyle !== 'undefined'?extraStyle:{})}
                            onReset={onRemoveHandler}
                            fields={fields}
                            showFields={(typeof showFields !== 'undefined'?showFields:['name'])}
                            searchParams={searchParams}
                            model={model}
                            extraFilter={extraFilter}
                            disabled={disabled}
                        />}
                        {typeof subAddButton !== 'undefined' && typeof subAddButtonData !== 'undefined' && subAddButton && !disabled  &&
                           <>
                               <a
                                   href="#"
                                   onClick={subAddButtonData.handler}
                                   id={subAddButtonData.id}
                                   className={subAddButtonData.class}
                               >
                                   <i className={subAddButtonData.i}></i>
                                   <span>
              {subAddButtonData.label}
          </span>
                               </a>
                           </>
                        }
                        <div id={(typeof container !== 'undefined'?container:'order-vcard')} className=''>
                        </div>
                        {typeof helpText !== 'undefined' && <><span className="help-text">{helpText}</span></> }
                    </div>

                </>
            }
        </div>
    );
};
export default FormItem;